/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon24Regular = forwardRef('AttachLinkOffIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.03 1.97a.75.75 0 0 0-1.06 1.06l19 19a.75.75 0 1 0 1.06-1.06l-3.24-3.241A6 6 0 0 0 17 6h-2.75a.75.75 0 0 0 0 1.5H17a4.5 4.5 0 0 1 .53 8.97l-3.72-3.72h2.44a.75.75 0 0 0 0-1.5h-3.94L8.56 7.5h1.19a.75.75 0 0 0 0-1.5H7.06L3.03 1.97Z" }),
        React.createElement("path", { d: "M1 12a5.994 5.994 0 0 1 2.625-4.961L4.71 8.125A4.5 4.5 0 0 0 7 16.5h2.749a.75.75 0 0 1 0 1.5H7a6 6 0 0 1-6-6Z" }),
        React.createElement("path", { d: "M7 11.25h.836l1.5 1.5H7a.75.75 0 0 1 0-1.5Z" })));
});
